import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout, Hero, About, Jobs, Projects, Cv, Contact } from '@components';

const StyledMainContainer = styled.main`
  counter-reset: section;
`;

const HomePage = ({ location, language }) => (
  <Layout location={location} language={language}>
    <StyledMainContainer className="fillHeight">
      <Hero />
      <About />
      <Jobs />
      <Projects />
      <Cv />
      <Contact />
    </StyledMainContainer>
  </Layout>
);

HomePage.propTypes = {
  location: PropTypes.object.isRequired,
  language: PropTypes.oneOf(['en', 'fr']).isRequired,
};

export default HomePage;
